import React from 'react';

import Calculate from './Calculate';
import Widget from './Widget';
import WidgetPieChart from './WidgetPieChart';
import WidgetBarGraph from './WidgetBarGraph';
import WidgetFunnelChart from './WidgetFunnelChart';
import WidgetMultiBarGraph from './WidgetMultiBarGraph';
import WidgetMultiLineChart from './WidgetMultiLineChart';
import ReportConst from '../../util/ReportConst';

class ReportWidget extends React.Component {

  render() {
    const viewType = this.props.view_type;
    const type = this.props.type;
    const model = this.props.model;
    const subModel = this.props.subModel;
    let x = this.props.x;
    let y = this.props.y;
    const z = this.props.z;
    const filters = this.props.filters;
    const data = this.props.data;
    const name = this.props.name;
    let xModel;
    let yModel = model;
    if(x && x.includes('.')) {
      const tmp = x.split('.');
      x = tmp[1];
      if(model && model.includes(' ' + tmp[0])) {
        xModel = model;
      } else if(subModel && subModel.includes(' ' + tmp[0])) {
        xModel = subModel;
      } else {
        xModel = null;
      }
    } else if(x) {
      xModel = model;
    }

    if(y && y.includes('.')) {
      const tmp = y.split('.');
      y = tmp[1];
      if(model && model.includes(' ' + tmp[0])) {
        yModel = model;
      } else if(subModel && subModel.includes(' ' + tmp[0])) {
        yModel = subModel;
      } else {
        yModel = null;
      }
    } else if(y) {
      yModel = model;
    }

    if(xModel && xModel.includes(' ')) {
      xModel = xModel.split(' ')[0];
    }
    if(yModel && yModel.includes(' ')) {
      yModel = yModel.split(' ')[0];
    }
    
    let table = [];
    if(type === ReportConst.Select
      || (type === ReportConst.Complex && !x && y)) {
      table = Calculate.select(xModel, yModel, x, y, z, filters, data);
    } else if(type === ReportConst.SelectToSelect
      || (type === ReportConst.Complex && x && y)) {
      table = Calculate.select2Select(xModel, yModel, x, y, z, filters, data);
    } /*else if(type === ReportConst.SelectToTime) {
      table = Calculate.selectToTime(xModel, yModel, x, y, z, filters, data);
    } */else if(type === ReportConst.SelectToMonth) {
      table = Calculate.selectToMonth(xModel, yModel, x, y, z, filters, data);
    } else if(type === ReportConst.Target) {
      table = Calculate.target(yModel, x, y, z, filters, data);
    }

    let widget = <div></div>;
    if(viewType === Widget.PieChart) {
      widget = <WidgetPieChart name={name} table={table} report={true} />
    } else if(viewType === Widget.BarGraph) {
      widget = <WidgetBarGraph name={name} table={table} report={true} />
    } else if(viewType === Widget.LineChart) {
      widget = <WidgetBarGraph name={name} table={table} report={true} />
    } else if(viewType === Widget.Funnel) 
      { widget = <WidgetFunnelChart name={name} table={table} report={true} /> }
    else if(viewType === Widget.MultiBarGraph)
      { widget = <WidgetMultiBarGraph name={name} table={table} report={true} /> }
    else if(viewType === Widget.MultiLineChart)
      { widget = <WidgetMultiLineChart name={name} table={table} report={true} /> }
    return(widget);
  }
}
export default ReportWidget;